export const supplierMap = {
	0: ['ASFINAG', 'DARS', 'BAZG'],
	3: ['ASFINAG'],
	6: ['SFDI'],
	7: ['DARS'],
	14: ['BAZG'],
};
